import * as React from 'react';
import { useSelector } from 'react-redux';

import { MainInfoLayout } from '../../components/MainInfoLayout';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';
import { SubtitleContainer } from '../Subtitle';
import { TitleContainer } from '../Title';
import { NewbuildingRatingsContainer } from '../NewbuildingRatings';
import { NewbuildingOverallRatingContainer } from '../NewbuildingOverallRating';

export function MainInfoContainer() {
  const { newbuildingNameFormatted } = useSelector(getNewbuildingInfo);

  return (
    <MainInfoLayout
      newbuildingNameFormatted={newbuildingNameFormatted}
      title={<TitleContainer />}
      subtitle={<SubtitleContainer />}
      newbuildingRatings={<NewbuildingRatingsContainer />}
      newbuildingOverallRating={<NewbuildingOverallRatingContainer />}
    />
  );
}
